/**
 * The Civil preview, at `/civil`: five tasks on one house, from the roof
 * down (docs/foundations.md §8). A preview of a discipline, not the course:
 * the page says so, and its end asks whether you want the full one.
 */
import { useStrings } from '../../state/useLocale';
import { TrackPage } from '../tracks/TrackPage';
import { Disciplines } from '../foundations/Disciplines';
import { CIVIL_STEPS } from './steps';

export function Civil() {
  const s = useStrings().civil;
  return (
    <TrackPage track="civil" text={s} steps={CIVIL_STEPS}>
      <Disciplines here="civil" />
    </TrackPage>
  );
}
